import { render, staticRenderFns } from "./UserNavSection.vue?vue&type=template&id=be1b840a&scoped=true&"
import script from "./UserNavSection.vue?vue&type=script&lang=js&"
export * from "./UserNavSection.vue?vue&type=script&lang=js&"
import style0 from "./UserNavSection.vue?vue&type=style&index=0&id=be1b840a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1b840a",
  null
  
)

export default component.exports